import { StyledBreadCrumb } from "./styled"

interface BreadCrumbModuleProps {
    items: { title: string | JSX.Element, href: string }[]
}

export const BreadCrumbModule = ({ items }: BreadCrumbModuleProps) => {
    return <StyledBreadCrumb items={items} />
}